import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import motorbike from '../assets/svg/projects/motorbike.svg'
import books from '../assets/svg/projects/books.svg'
import camera from '../assets/svg/projects/camera.svg'
import analysis from '../assets/svg/projects/analysis.svg'
import cvf from '../assets/svg/projects/cvf.svg'
import phone from '../assets/svg/projects/phone.svg'
import money from '../assets/svg/projects/money.svg'
import convention from '../assets/svg/projects/convention.svg'
import headphone from '../assets/svg/projects/headphone.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Bike Parts Manufacturer',
        projectDesc: 'This project aims to build for a bike parts manufacturer company. An admin can add, manage their parts. User can order parts and make payment. ',
        tags: ['React', 'Firebase', 'MongoDB', 'Stripe(Payment)', 'daisyUI'],
        code: 'https://github.com/AliHossain01/bike-parts-manufacturer-client-side',
        demo: 'https://bike-parts-cd343.web.app/',
        image: motorbike,
        url: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/keep-calm-details-coming-soon.webp'
    },
    {
        id: 2,
        projectName: 'Books Warehouse Management',
        projectDesc: 'This project is for books warehouse management. New books can be added, deleted from the collection',
        tags: ['React', 'Firebase', 'Bootstrap', 'MongoDB',],
        code: 'https://github.com/AliHossain01/-warehouse-management-client-side',
        demo: 'https://warehouse-management-8e867.web.app/',
        image: books,
        url: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/keep-calm-details-coming-soon.webp'
    },
    {
        id: 3,
        projectName: 'Photography Services',
        projectDesc: 'This website is for a person for his service providing. An user can invite the service provider',
        tags: ['React', 'Firebase', 'Bootstrap'],
        code: 'https://github.com/AliHossain01/photography-service',
        demo: 'https://photography-services-e857d.web.app/',
        image: camera,
        url: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/keep-calm-details-coming-soon.webp'
    },
    {
        id: 4,
        projectName: 'Product Analysis',
        projectDesc: 'This project involves the product"s  month-wise sell, investment, and revenue.',
        tags: ['React', 'Tailwind', 'Recharts'],
        code: 'https://github.com/AliHossain01/-product-analysis-website',
        demo: 'https://product-analysis-website-cvf.netlify.app/',
        image: analysis,
        url: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/keep-calm-details-coming-soon.webp'
    },
    {
        id: 5,
        projectName: 'Cholonbil Village Foods',
        projectDesc: 'A Simple E-commerce application',
        tags: ['React', 'CSS'],
        code: 'https://github.com/AliHossain01/lucy-one-product',
        demo: 'https://cvf-website.netlify.app/',
        image: cvf,
        url: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/keep-calm-details-coming-soon.webp'
    },
    {
        id: 6,
        projectName: 'Phones Finder',
        projectDesc: 'User can search a phone using phones name.',
        tags: ['API', 'JavaScript'],
        code: 'https://github.com/AliHossain01/phone-finder',
        demo: 'https://phone-finder-assignmet.netlify.app/',
        image: phone,
        url: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/keep-calm-details-coming-soon.webp'
    },
    {
        id: 7,
        projectName: 'Money Master',
        projectDesc: 'Monthly money calculator.',
        tags: ['JavaScript', 'CSS'],
        code: 'https://github.com/AliHossain01/money-master',
        demo: 'https://money-master-ali.netlify.app/',
        image: money,
        url: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/keep-calm-details-coming-soon.webp'
    },
    {
        id: 8,
        projectName: 'Convention Center',
        projectDesc: 'Convention Center landing page using Bootstrap',
        tags: ['HTML', 'CSS', 'Bootstrap'],
        code: 'https://github.com/AliHossain01/khulna-convention-center',
        demo: 'https://convention-center-2.netlify.app/',
        image: convention,
        url: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/keep-calm-details-coming-soon.webp'
    },
    {
        id: 9,
        projectName: 'influencer Gear',
        projectDesc: 'This is a simple landing page for showing different gears. ',
        tags: ['HTML', 'CSS'],
        code: 'https://github.com/AliHossain01/influencer-asignment-2',
        demo: 'https://alihossain01.github.io/influencer-asignment-2/',
        image: headphone,
        url: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/keep-calm-details-coming-soon.webp'
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/